import { styled } from "@acko-tech/building-blocks.ui.common";
import ChevronDown from "@public/images/chevron-down.svg";
import CalendarIcon from "@public/images/bike-journey/calender-icon.svg";
import PopoverCard from "@components/Bike/mmv/common/PopoverCard";

export const StyledChevronDown = styled(ChevronDown)`
  width: 12px;
  height: 7px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 22px;
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  width: 15px;
  height: 13px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 22px;
`;

export const StyledPopoverCard = styled(PopoverCard)`
  top: 92px;
  width: 400px;
  max-height: 360px;
  z-index: 10;
`;
